import {AppRoute} from './app-route';
import {AppParameter} from './app-parameter';

export const APP_ROOT = new AppRoute('/');
export const APP_TERMS = new AppRoute('/terms');
export const APP_403 = new AppRoute('/403');
export const APP_401 = new AppRoute('/401');

export const PARAM_ENTITY_ID = new AppParameter('entityId');
export const APP_ENTITIES = new AppRoute('/entities');
export const APP_ENTITY = new AppRoute(APP_ENTITIES, PARAM_ENTITY_ID);
export const APP_ENTITY_INFORMATION = new AppRoute(APP_ENTITY, 'information');
export const APP_ENTITY_RELATED_PARTIES = new AppRoute(APP_ENTITY, 'related-parties');
export const APP_ENTITY_INVOICES = new AppRoute(APP_ENTITY, 'invoices');
export const APP_ENTITY_DOCUMENTS = new AppRoute(APP_ENTITY, 'documents');
export const APP_ENTITY_HOLDINGS = new AppRoute(APP_ENTITY, 'holdings');
export const APP_ENTITY_BANKING = new AppRoute(APP_ENTITY_HOLDINGS, 'banking');
export const APP_ENTITY_ASSETS = new AppRoute(APP_ENTITY_HOLDINGS, 'assets');
export const APP_ENTITY_INVESTMENTS = new AppRoute(APP_ENTITY_HOLDINGS, 'investments');
export const APP_ENTITY_LOANS = new AppRoute(APP_ENTITY_HOLDINGS, 'loans');
export const APP_ENTITY_SHARE_REGISTER = new AppRoute(APP_ENTITY, 'share-register');

export const PARAM_INVOICE_ID = new AppParameter('id');
export const PARAM_INVOICE_CURRENCY_CODE = new AppParameter('currencyCode');
export const APP_INVOICES = new AppRoute('/invoices');
export const APP_INVOICES_SUMMARY = new AppRoute(APP_INVOICES, 'summary');
export const APP_INVOICE_DETAILS = new AppRoute(APP_INVOICES, 'details', PARAM_INVOICE_ID, PARAM_INVOICE_CURRENCY_CODE);

export const APP_DOCUMENTS = new AppRoute('/documents');

export const APP_MESSAGES = new AppRoute('/messages');

export const PARAM_TASK_ID = new AppParameter('taskId');
export const PARAM_TASK_STEP_ID = new AppParameter('stepId');
export const APP_TASKS = new AppRoute('/tasks');
export const APP_TASK = new AppRoute(APP_TASKS, PARAM_TASK_ID);
export const APP_TASK_STEPS = new AppRoute(APP_TASK, 'steps');
export const APP_TASK_STEP = new AppRoute(APP_TASK_STEPS, PARAM_TASK_STEP_ID);

export const PARAM_REQUEST_ID = new AppParameter('requestId');
export const PARAM_REQUEST_STEP_ID = new AppParameter('stepId');
export const APP_REQUESTS = new AppRoute('/requests');
export const APP_REQUESTS_NEW = new AppRoute(APP_REQUESTS, 'new');
export const APP_REQUESTS_IN_PROGRESS = new AppRoute(APP_REQUESTS, 'in-progress');
export const APP_REQUESTS_IN_REVIEW = new AppRoute(APP_REQUESTS, 'in-review');
export const APP_REQUESTS_COMPLETED = new AppRoute(APP_REQUESTS, 'completed');
export const APP_REQUEST = new AppRoute(APP_REQUESTS, 'request', PARAM_REQUEST_ID);
export const APP_REQUEST_STEPS = new AppRoute(APP_REQUEST, 'steps');
export const APP_REQUEST_STEP = new AppRoute(APP_REQUEST_STEPS, PARAM_REQUEST_STEP_ID);
